import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";
import { LoginResponse } from "./LoginResponse";

const ENDPOINT = "/Auth/AutoLogin";

export class AutoLoginCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    public async execute(): Promise<LoginResponse> {
        var res = await this.executeCommand();
        return new LoginResponse(res);
    }
}
